<template>
  <drag tag="tr" class="table-item" :transfer-data="opPackage" :draggable="!inMap"
        @dragstart="$store.commit('routing/setDropzoneShow', true)"
        @dragend="$store.commit('routing/setDropzoneShow', false)" v-if="!isMobile">
    <div slot="image" class="dragslot">Package {{ opPackage.id }}</div>
    <td class="pkg-check"><input type="checkbox" :value="opPackage.id" v-model="checkedPackages" /></td>
    <td class="pkg-id"><a :href="'/#/package/' + opPackage.id" target="_blank">{{ opPackage.id }}</a></td>
    <td class="pkg-status">
      <div v-if="opPackage.pendingOffer && opPackage.pendingOffer.show">
        <span class="status pending-offer">Pending Offer</span>
        <i class="fas fa-spinner fa-spin" v-if="checkingDriver"></i>
        <b class="timer" v-else>{{timer}}s</b>
      </div>
      <div :class="['status', opPackage.statusClass]" v-else>{{ opPackage.status }}</div>
    </td>
    <td class="pkg-pickup-time" @dblclick="editPickupDate(opPackage)">{{ opPackage.pickupTime }}</td>
    <td class="pkg-pickup">{{ getAddress(opPackage.rsvps[0].pickup) }}</td>
    <td class="pkg-dropoff">
      <div class="last-dropoff" v-if="opPackage.status === 'ONBOARD'">
        <span @mouseover="showEtaPopup" @mouseout="hideEtaPopup">{{ getAddress(opPackage.rsvps[opPackage.rsvps.length - 1].dropoff) }}</span>
        <div v-bind:class="{ 'eta-popup': true, show: etaPopup.show }">
          <i class="fa fa-spinner fa-spin" v-show="etaPopup.loading"></i>
          <strong v-show="!etaPopup.loading">{{ etaPopup.label }}</strong>
        </div>
      </div>
      <div v-else>{{ getAddress(opPackage.rsvps[opPackage.rsvps.length - 1].dropoff) }}</div>
    </td>
    <td class="pkg-service">
      <span class="service-type" :style="{background: opPackage.service.color}">{{ opPackage.service.label }}</span>
    </td>
    <td class="pkg-driver">
      <span v-if="opPackage.driver === null">N/A</span>
      <div v-else>
        <a :href="'/#/provider/' + opPackage.driver.ID" target="_blank">
          {{ opPackage.driver.firstName }} {{ opPackage.driver.lastName }}
        </a>

        <div v-if="opPackage.driver.phone !== null && opPackage.driver.phone !== ''">
          <a href="javascript:;" @click="callPhone(opPackage.driver)">
           ({{ opPackage.driver.phone }})
          </a>
        </div>
      </div>
    </td>
    <td class="pkg-payment">${{ (opPackage.payment + opPackage.bonus + opPackage.tip + opPackage.gasFee).toFixed(2) }}</td>
    <td class="pkg-ada">
      <div v-if="opPackage.ada === null || (!opPackage.ada.wheelchair && !opPackage.ada.serviceDog)">N/A</div>
      <div v-else>
        <span v-show="opPackage.ada.serviceDog"><svg-dog></svg-dog></span>
        <span v-show="opPackage.ada.wheelchair"><svg-wheelchair></svg-wheelchair></span>
      </div>
    </td>
    <td class="pkg-stops">{{ opPackage.stops/2 }}</td>
    <td class="pkg-pax">{{ opPackage.pax }}</td>
    <td class="pkg-luggage">{{ opPackage.luggage }}</td>
    <td class="pool-yes pkg-in-pool" v-show="opPackage.inPool"><i class="fas fa-check-circle fa-fw fa-lg"></i></td>
    <td class="pool-no pkg-in-pool" v-show="!opPackage.inPool"><i class="fas fa-times-circle fa-fw fa-lg"></i></td>
    <td class="map-button pkg-map">
      <a href="javascript:;" @click="toggleInMap"
         v-bind:class="{ selected: inMap }">
        <i class="fas fa-map-marker-alt"></i>
      </a>
    </td>
  </drag>
  <div v-else class="table-card">
    <div class="row-1">
      <div>
        <input type="checkbox" :value="opPackage.id" v-model="checkedPackages" />
        <a :href="'/#/package/' + opPackage.id" target="_blank">{{ opPackage.id }}</a>
        <div v-bind:class="'status ' + opPackage.statusClass">{{ opPackage.status }}</div>
      </div>
      <div class="map-button"  @click="toggleInMap">
        <a href="javascript:;"
         v-bind:class="{ selected: inMap }">
          <i class="fas fa-map-marker-alt"></i>
        </a>
      </div>
    </div>
    <div>
      <div>Pickup Time: {{ opPackage.pickupTime }}</div>
    </div>
    <div>
      <div>First Pickup: {{ getAddress(opPackage.rsvps[0].pickup) }}</div>
    </div>
    <div>
      <span>Last Drop-Off:
        <div class="last-dropoff" v-if="opPackage.status === 'ONBOARD'">
        <span @mouseover="showEtaPopup" @mouseout="hideEtaPopup">{{ getAddress(opPackage.rsvps[opPackage.rsvps.length - 1].dropoff) }}</span>
        <div v-bind:class="{ 'eta-popup': true, show: etaPopup.show }">
          <i class="fa fa-spinner fa-spin" v-show="etaPopup.loading"></i>
          <strong v-show="!etaPopup.loading">{{ etaPopup.label }}</strong>
        </div>
      </div>
      <div v-else>{{ getAddress(opPackage.rsvps[opPackage.rsvps.length - 1].dropoff) }}</div>
      </span>
    </div>
    <div>
      <span>Driver:
        <span v-if="opPackage.driver === null">N/A</span>
        <div v-else>
          <a :href="'/#/provider/' + opPackage.driver.ID" target="_blank">
            {{ opPackage.driver.firstName }} {{ opPackage.driver.lastName }}
          </a>

          <div v-if="opPackage.driver.phone !== null && opPackage.driver.phone !== ''">
            <a href="javascript:;" @click="callPhone(opPackage.driver)">
            ({{ opPackage.driver.phone }})
            </a>
          </div>
        </div>
      </span>
    </div>
    <div>
      <span>Payment: ${{ (opPackage.payment + opPackage.bonus + opPackage.tip).toFixed(2) }}</span>
    </div>
    <div class="toggle-div">
      <div class="row-7">
        <div>
          <span><i class="fas fa-user-friends icon"></i>{{ opPackage.pax }}</span>
          <span><i class="fas fa-suitcase icon"></i>{{ opPackage.luggage }}</span>
          <span><strong><i class="fas fa-ban icon"></i></strong> {{ opPackage.stops/2 }}</span>
          <span><strong>ADA:</strong>
            <span v-if="opPackage.ada === null || (!opPackage.ada.wheelchair && !opPackage.ada.serviceDog)">N/A</span>
            <span v-else>
              <span v-show="opPackage.ada.serviceDog"><svg-dog></svg-dog></span>
              <span v-show="opPackage.ada.wheelchair"><svg-wheelchair></svg-wheelchair></span>
            </span>
            </span>
        </div>
        <span>In Pool:
          <span class="pool-yes pkg-in-pool"  v-show="opPackage.inPool"><i class="fas fa-check-circle fa-fw fa-lg"></i></span>
          <span class="pool-no pkg-in-pool"  v-show="!opPackage.inPool"><i class="fas fa-times-circle fa-fw fa-lg"></i></span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import SvgDog from '@/components/Partials/SVG/ServiceDog'
import SvgWheelchair from '@/components/Partials/SVG/Wheelchair'
export default {
  name: 'package-row',
  data () {
    return {
      hereMaps: {
        platform: {},
      },
      etaPopup: {
        show: false,
        loading: false,
        label: ''
      },
      timer: 20,
      checkingDriver: false
    }
  },
  props: ['opPackage', 'forDispatch', 'isMobile'],
  components: { SvgDog, SvgWheelchair },
  computed: {
    inMap () {
      let self = this
      let mapItems = self.$store.state.routing.dropzone.items
      let item = mapItems.filter(mapItem => mapItem.packageID === self.opPackage.id)
      return item.length > 0
    },
    checkedPackages: {
      get () {
        if (this.forDispatch) {
          return this.$store.state.routing.packages.checkedForDispatch
        }
        return this.$store.state.routing.packages.checked
      },
      set (value) {
        if (this.forDispatch) {
          this.$store.commit('routing/updateCheckedPackagesForDispatch', value)
        } else {
          this.$store.commit('routing/updateCheckedPackages', value)
        }
      }
    }
  },
  methods: {
    toggleInMap () {
      let self = this
      if (self.inMap) {
        self.$store.commit('routing/removeDropzoneItems', self.opPackage)
        if (self.opPackage.driver !== null) {
          self.$store.commit('routing/removeDropzoneDriver', {
            packageID: self.opPackage.id,
            driver: self.opPackage.driver
          })
        }
        return
      }

      let items = this.$store.state.routing.dropzone.items
      if (items.length) {
        if (items[0].serviceId !== self.opPackage.serviceId) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'Different service types cannot be packaged together.'
          })
          return
        }
      }

      self.$store.commit('routing/addDropzoneItem', self.opPackage)
      if (self.opPackage.driver !== null) {
        self.$store.commit('routing/addDropzoneDriver', {
          packageID: self.opPackage.id,
          driver: self.opPackage.driver
        })
      }
    },
    getAddress (location) {
      if (location.geofenceType === 'airport' &&
          location.geofenceName !== '') {
        let result = location.geofenceName
        if (location.terminal && location.terminal !== '' && location.terminal !== 'undefined') {
          result += ' - Terminal ' + location.terminal
        }
        return result
      }
      return location.title

      // let address = ''
      // if (location.address2 && location.address2 !== '' && location.address2 !== 'undefined') {
      //   address = address + location.address2 + ' '
      // }
      // if (location.address1) {
      //   address = address + location.address1 + ', '
      // }
      // if (location.city) {
      //   address = address + location.city + ' '
      // }
      // if (location.state) {
      //   address = address + location.state + ' '
      // }
      // if (location.zip) {
      //   address = address + location.zip
      // }

      // return address
    },
    callPhone (info) {
      let self = this
      self.$plugins.phone.startCall(self, {
        phone: info.phone,
        name: info.firstName + ' ' + info.lastName
      })
    },
    showEtaPopup (e) {
      let self = this
      self.etaPopup.show = true
      if (self.opPackage.driver === null) {
        self.etaPopup.loading = false
        self.etaPopup.label = 'Cannot find the driver.'
        return
      }
      self.etaPopup.loading = true
      self.etaPopup.label = ''

      self.$sdk.get('/provider/' + self.opPackage.driver.ID + '/tracks', {
        token: self.$store.state.session.sessionToken
      }, r => {
        if (r.error) {
          self.etaPopup.loading = false
          self.etaPopup.label = 'Cannot find the driver.'
          return
        }

        if (r.list.length <= 0) {
          self.etaPopup.loading = false
          self.etaPopup.label = 'Cannot find the driver.'
          return
        }
        let location = r.list[0]
        let waypoints = []
        waypoints.push(location)

        let legs = self.opPackage.legs
        for (let i = 0; i < legs.length; i++) {
          let leg = legs[i]

          if (!leg.isPickup && leg.status === 'ONTHEWAY') {
            waypoints.push({
              lat: leg.location.lat,
              lng: leg.location.lng
            })
            continue
          }

          if (!leg.isPickup && (leg.status === 'ONBOARD' || leg.status === 'ONTHEWAY')) {
            waypoints.push({
              lat: leg.location.lat,
              lng: leg.location.lng
            })
            continue
          }
        }

        // let request = {
        //   origin: waypoints.shift(),
        //   destination: waypoints.pop(),
        //   travelMode: google.maps.TravelMode.DRIVING // eslint-disable-line no-undef
        // }

        let stopovers = []
        for (let i = 0; i < waypoints.length; i++) {
          stopovers.push({
            location: { lat: waypoints[i].lat, lng: waypoints[i].lng },
            stopover: false
          })
        }

        // if (stopovers.length > 0) {
        //   request.waypoints = stopovers
        // }

        let origin = [...waypoints].shift()
        let destination = [...waypoints].pop()
        self.calculateRoute(origin, destination)
        // let direction = new google.maps.DirectionsService() // eslint-disable-line no-undef
        // direction.route(request, (response, status) => {
        //   self.etaPopup.loading = false
        //   if (status !== google.maps.DirectionsStatus.OK) { // eslint-disable-line no-undef
        //     self.etaPopup.label = 'Cannot find the driver.'
        //     return
        //   }

        //   let legs = response.routes[0].legs
        //   let duration = 0
        //   for (let j = 0; j < legs.length; j++) {
        //     duration = duration + legs[j].duration.value
        //   }
        //   let eta = moment().add(duration, 'seconds')
        //   let format = 'MM/DD/YYYY hh:mm A'
        //   if (self.$settings.get('MilitaryTimeBackoffice') === '1') {
        //     format = 'MM/DD/YYYY HH:mm'
        //   }
        //   self.etaPopup.label = 'ETA: ' + eta.format(format)
        // })
      })
    },
     calculateRoute (origin, destination) {
      let self = this
      let router = self.hereMaps.platform.getRoutingService(null, 8)
      let routeRequestParams = {
        routingMode: 'fast',
        transportMode: 'car',
        origin: `${origin.lat},${origin.lng}`,
        destination: `${destination.lat},${destination.lng}`,
        return: 'polyline,turnByTurnActions,actions,instructions,travelSummary'
      }

      router.calculateRoute(
        routeRequestParams,
        self.onCalculateSuccess,
        self.onCalculateError
      )
    },
    onCalculateSuccess (result) {
      let self = this
      self.etaPopup.loading = false
      if (!result.routes.length) return
      var route = result.routes[0].sections[0]

      let eta = moment().add(route.travelSummary.duration, 'seconds')
      let format = 'MM/DD/YYYY hh:mm A'
      if (self.$settings.get('MilitaryTimeBackoffice') === '1') {
        format = 'MM/DD/YYYY HH:mm'
      }
      self.etaPopup.label = 'ETA: ' + eta.format(format)
    },
    onCalculateError (data) {
      this.etaPopup.loading = false
      this.etaPopup.label = 'Cannot find the driver.'
      this.error('ROUTING ERROR', data)
    },
    hideEtaPopup () {
      let self = this
      self.etaPopup.show = false
      self.etaPopup.loading = false
      self.etaPopup.label = ''
    },
    editPickupDate (pkg) {
      this.$store.commit('routing/setPickupTimeModal', {
        show: true,
        id: pkg.id,
        value: pkg.pickupTime
      })
    },
    startPendingOfferTimer () {
      let self = this
      if (self.timer < 0) {
        self.checkingDriver = true
        self.$sdk.get(`/admin/package/${self.opPackage.id}`, {
          token: self.$store.state.session.sessionToken
        }, r => {
          self.checkingDriver = false
          if (!r.error) {
            let statusClass = r.package.packageStatus ? r.package.packageStatus : r.package.status
            let status = r.package.packageStatus ? r.package.packageStatus.toUpperCase() : r.package.status.toUpperCase()

            if (statusClass === 'requires_dispatch') {
              statusClass = 'requires-dispatch'
              status = 'REQUIRES DISPATCH'
            }

            if (statusClass === 'autodispatch') {
              statusClass = 'auto-dispatch'
              status = 'AUTO DISPATCH'
            }

            if (statusClass === 'cancelled') {
              statusClass = 'canceled'
              status = 'CANCELED'
            }

            if (statusClass === 'complete') {
              status = 'COMPLETED'
            }

            if (statusClass === 'ready') {
              status = 'READY TO GO'
            }

            self.$store.commit('routing/updateRsvpStatus', {
              id: self.opPackage.id,
              status: status,
              statusClass: statusClass
            })
          }
          self.$store.commit('routing/setPendingOffer', {
            id: self.opPackage.id,
            show: false,
            timer: 0
          })
        })
        return
      }
      setTimeout(() => {
        self.timer--
        self.startPendingOfferTimer()
      }, 1000)
    }
  },
  watch: {
    'opPackage.pendingOffer' (val) {
      this.timer = val.timer
      if (this.timer) this.startPendingOfferTimer()
    }
  },
  mounted () {
    this.hereMaps.platform = new window.H.service.Platform({apikey: CONFIG.hereApi.key})
    let defaultLayers = this.hereMaps.platform.createDefaultLayers()
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_status';
@import '../../assets/scss/_service-types';
.dragslot {
  font-weight: 700;
  background-color: #fff;
  padding: 5px;
  box-shadow: 2px 0 8px rgba(0,0,0,0.25);
  border: 1px solid rgba(0,0,0,0.4);
  border-radius: 3px;
}

.table-item {
  background-color: #fff;
  border: 1px solid rgba(0,0,0,0.3);
  position: relative;

  & input[type="checkbox"]{
    margin-top: 0;
    width: auto;
  }

  & td{
    padding: 5px;
    text-align: center;
    font-size: 12px;
    margin-bottom: 5px;

    & a{ font-weight: 700; }

    &.map-button{
      padding: 10px;

      & a{
        color: #fff;
        background-color: #aaa;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        display: inline-block;
        border-radius: 30px;
        transition: all 250ms;

        & i {line-height: inherit;}

        &.disabled{
          pointer-events: none;
          opacity: 0.5;
          background-color: #bbb;
        }
        &.selected{
          background-color: #26D97A;
        }
      }
    }

    &.pool-yes { color: #26D97A; }
    &.pool-no { color: #F20D0D; }

    &.pkg-check{ width: 24px!important; }
    &.pkg-id{ width: 53px!important; }
    &.pkg-status{ width: 90px!important; }
    &.pkg-pickup-time{ width: 80px!important; }
    &.pkg-pickup, &.pkg-dropoff{ width: 140px!important; }
    &.pkg-driver{ width: 86px!important; }
    &.pkg-payment{ width: 65px!important; }
    &.pkg-ada{ width: 50px!important; }
    &.pkg-stops{ width: 47px!important; }
    &.pkg-pax{ width: 32px!important; }
    &.pkg-luggage{ width: 66px!important; }
    &.pkg-in-pool{ width: 43px!important; }
    &.pkg-map{ width: 40px!important; }
  }
}

.last-dropoff {
  position: relative;
  text-decoration: underline;
  font-weight: 700;

  & .eta-popup {
    position: absolute;
    top: 0;
    left: 100%;
    background-color: #e5e5e5;
    border: 1px solid rgba(0,0,0,0.2);
    box-shadow: 0 2px 4px rgba(0,0,0,0.15);
    padding: 10px;
    overflow: hidden;
    height: 0;
    width: 0;
    padding: 0;
    transition: all 250ms;
    text-decoration: none;
    font-weight: 400;
    border-radius: 3px;
    text-align: center;

    &.show {
      padding: 5px;
      width: 170px;
      height: auto;
    }
  }
}

.status{
  &.pending-offer{
    background: #ef7a0b;
    line-height: 12px;
    position: relative;
    overflow: hidden;
    box-shadow: 0 0 2px 1px rgba(0,0,0, .2);

    &:after {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: linear-gradient(
        130deg,
        rgba(227, 227, 227, 0) 0%,
        rgba(227, 227, 227, 0) 40%,
        rgba(255, 255, 255, 0.7) 50%,
        rgba(227, 227, 227, 0) 60%,
        rgba(227, 227, 227, 0) 100%
      );
      animation: gradient-animation_2 1.2s linear infinite;
    }
  }
}
@keyframes gradient-animation_2 {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}
.timer{
  display: inline-block;
}

@media only screen and (max-width: 430px) {
  .table-card {
    border: 1px solid #ccc;
    margin: 10px;
    margin-bottom: 15px;
    padding: 10px;
    border-bottom: 5px solid #aaa9;
    border-radius: 10px;
    font-size: 13px;
    background-color: #fff;

    a {
      font-weight: 900;
    }

    i {
      color: #0d79f2;
    }

    > div {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-bottom: 3px;

      &.see-more {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
      }
    }

    .toggle-div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .toggle {
        font-size: 16px;
        color: #0e79f2;
      }

      svg {
        width: 15px;
        height: 15px;
      }

      .row-7 {
        display: flex;
        width: 100%;
        justify-content: space-between;
        .pool-yes { 
          i {
            color: #26D97A;
          }
        }
        .pool-no {
          i {
            color: #F20D0D;
          }
        }
      }
    }

    .row-1 {
      .link {
        padding-bottom: 5px;
        display: inline-block;
      }
      .rtg {
        display: inline-block;
        margin: 4px;
      }
      i {
        color: #26D97A;
      }
      input {
        display: inline-block;
        margin: 0;
        width: 15px;
        height: 15px;
        margin-right: 5px;
      }
      .map-button {
        a {
          background-color: #aaa;
          width: 30px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border-radius: 30px;
          -webkit-transition: all 250ms;
          transition: all 250ms;
          display: flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          i {
            color: #fff;
          }
          &.disabled{
            pointer-events: none;
            opacity: 0.5;
            background-color: #bbb;
          }
          &.selected{
            background-color: #26D97A;
          }
        }
      }
    }

    .row-2 {
      display: flex;
      justify-content: unset;
      gap: 5px;
      align-items: center;
      .image {
        img {
          min-width: 30px;
          max-width: 30px;
        }
      }
    }

    .row-7 {
      strong {
        color: #666;
      }
      i {
        color: #666;
        margin: 0 3px;
      }
    }

    .row-8 {
      justify-content: center;
      .actions {
        display: flex;
        span {
          padding: 8px 20px;
        }
        .notes {
          i {
            color: #fff;
          }
        }
      }
    }

    .clock {
      i {
        color: #F25E0D;
      }
    }

    .pickup {
      i {
        color: #d92626;
      }
    } 

    .dropoff {
      i {
        color: #26D97A;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Routing/PackageRow.vue